import React, { useState } from 'react';
import Clock from '../components/Clock';
import FullscreenClock from '../components/FullscreenClock';
import PhoneMockup from '../components/PhoneMockup';
import SEOHead from '../components/SEOHead';
import './Home.css';

const Home = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const enterFullscreen = async () => {
    try {
      await document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } catch (error) {
      // Fallback if fullscreen API is not available
      setIsFullscreen(true);
    }
  };

  const exitFullscreen = async () => {
    try {
      if (document.fullscreenElement) {
        await document.exitFullscreen();
      }
      setIsFullscreen(false);
    } catch (error) {
      setIsFullscreen(false);
    }
  };

  if (isFullscreen) {
    return <FullscreenClock onExit={exitFullscreen} />;
  }

  return (
    <>
      <SEOHead
        title="OneTimer - Focus Timer"
        description="Free 24-hour online clock tool. Perfect for timelapses, productivity tracking, and focused work sessions. Click anywhere to go fullscreen!"
        keywords="24 hour clock, online clock, fullscreen clock, timer, timelapse, productivity, time tracking"
        path="/"
      />
      <div className="home-container">
        <div className="hero-section">
          <Clock onFullscreenClick={enterFullscreen} />
        </div>
        
        <div className="app-promotion">
          <div className="app-promotion-content">
            <div className="app-text">
              <h2 style={{ color: '#FF3333' }}>your time is limited.</h2> 
              <p>
                reclaim it and track with obsession.
              </p>
              <div className="app-mockup">
              <PhoneMockup />
            </div>
              <div className="app-links">
                <a href="https://apps.apple.com/us/app/onetimer-focus-app/id6748548290?ppid=a293ba95-ac02-44b7-928a-2bc117be92c9" target="_blank" rel="noopener noreferrer" className="store-badge">
                  <img src="/images/app-store-badge.webp" alt="Download on the App Store" />
                </a>
                <a href="/android-waitlist" className="store-badge">
                  <img src="/images/google-play-badge.png" alt="Get it on Google Play" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;